export const AUTH = {
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
  };
  